import { Components, Theme, PaletteMode } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';
import dimensions from '../dimensions';

export const MuiTooltipTheme = (mode: PaletteMode): Components<Theme>['MuiTooltip'] => {
  const { tokens, componentTokens } = themePalette(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      tooltip: {
        backgroundColor: componentTokens.tooltip.colors.neutral.background.default,
        color: componentTokens.tooltip.colors.neutral.text.default,
        fontWeight: typographyTokens.fontWeights.regular,
        fontSize: typographyTokens.fontSizes.sm,
        lineHeight: typographyTokens.lineHeights.xs,
        padding: spacing(2), // 8px
        borderRadius: spacing(1), // 4px
        boxShadow: `0 2px 8px ${tokens.effects.shadows.base.base}`,
        backdropFilter: 'blur(10px)',
      },
      arrow: {
        color: componentTokens.tooltip.colors.neutral.background.default,
      },
    },
  };
};
